import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Datum from '@/interfaces/Datum';
import * as hcm from './HCM';
import * as d3 from 'd3';

@Component({})
export default class LinkGroup extends Vue {

  public drawLinks(
    // linkGroup: d3.Selection<SVGGElement, any, HTMLElement, unknown>,
    links: Array<d3.HierarchyPointLink<Datum>>,
    horizontalLayout: 'linearTidy' | 'radialTidy',
    duration: number = 500,
    source?: hcm.Component | undefined
  ): Promise<void> {
    const linkGroup = d3.select(this.$el);

    const linkGenerator = getLinkGenerator();

    const link = linkGroup
      .selectAll<SVGPathElement, d3.HierarchyPointLink<Datum>>('path')
      .data(links, d => `${d.target.data.id}`);

    // Enter any new links at the parent's previous position.
    const linkEnter = link
      .enter()
      .append('path')
      .attr('d', d => {
        const src = source ? source : d.target.data.source;
        const o = { x: src.data.x0!, y: src.data.y0! };
        return linkGenerator({ source: o, target: o });
      });

    // Transition links to their new position.
    const linkUpdate = link
      .merge(linkEnter)
      .transition()
      .duration(duration)
      .attr('d', linkGenerator);

    // Transition exiting nodes to the parent's new position.
    link
      .exit()
      .transition()
      .duration(duration)
      .attr('d', (d: any) => {
        const src = source ? source : d.target.data.source;
        const o = { x: src.x!, y: src.y! };
        return linkGenerator({ source: o, target: o });
      })
      .remove();

    return linkUpdate.end();

    function getLinkGenerator() {
      if (horizontalLayout === 'radialTidy') {
        return d3
          .linkRadial<any, any>()
          .angle(d => d.x)
          .radius(d => d.y);
      } else {
        return d3
          .linkVertical<any, any>()
          .x(d => d.x)
          .y(d => d.y);
      }
    }
  }

  protected mounted() {
    d3.select(this.$el)
      .attr('fill', 'none')
      .attr('stroke', '#555')
      .attr('stroke-opacity', 0.4)
      .attr('stroke-width', 1.5);
  }

}
